import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { PaginationObjectInterface } from '@components/components/pagination/pagination.component';
import { TableComponentInterface, TableDataServiceObjectInterface, TableRowItem } from './table.interface';

@Component({
  selector: 'sp-table',
  standalone: false,
  templateUrl: './table.component.html'

})
export class TableComponent implements OnInit, TableComponentInterface {
  @ViewChild('tableHead', { static: true }) tableHead;
  @Input() style = 'default';
  @Input() withCheckbox: boolean = false;
  @Input() size = 'normal';
  @Input() mutating = false;
  @Input() paginate = false;
  @Input() dynamicColumns = false;
  @Input() filter = false;
  @Input() sort = 'default';
  @Input() header = null;
  @Input() rows = null;
  @Input() filterInputs = null;
  @Input() tableSearch = false;
  @Input() fetchOnPaginate: boolean;
  @Output() OnRowSelect = new EventEmitter<Array<TableRowItem>>();
  @Input() DataService: TableDataServiceObjectInterface = {
    create: (row, formGroup, method) => {},
    update: (row, id, formGroup, method) => {},
    fetch: fieldname => {}
  };
  @Input() pagination: PaginationObjectInterface = {
    currentPage: 1,
    next: null,
    prev: null,
    last: 1,
    pageSize: 10
  };

  dateQuery: Record<string, unknown> = {};
  query: any = {};
  basicQuery: Record<string, unknown> = {};
  headerCheck: boolean;
  selectedRows: Array<TableRowItem>;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.fillQueryObject();
    this.handleErrors();
    if (!this.fetchOnPaginate) {
      this.DataService?.fetch(this.basicQuery);
    }
  }

  fillQueryObject() {
    if (this.header) {
      this.header.forEach(element => {
        this.query[element.title] = '';
      });
    }

    if (this.filterInputs) {
      this.filterInputs.forEach(item => {
        if (typeof item.value === 'string') {
          this.basicQuery[item.name] = item.value;
        }
      });
    }
  }

  getCheckedRows() {
    this.selectedRows = this.rows.filter(row => row.selected === true);
    const selectedCount = this.selectedRows.length;
    this.tableHead.headerCheck = false;
    if (selectedCount === this.rows.length) {
      this.tableHead.headerCheck = true;
    }
    this.OnRowSelect.emit(this.selectedRows);
  }

  getHeaderCheck(check: boolean) {
    this.selectedRows = [];
    this.tableHead.headerCheck = true;
    this.rows.forEach(row => {
      row.selected = check;
    });
    this.OnRowSelect.emit(this.rows.filter(row => row.selected === true));
  }

  handleErrors() {
    if (this.header) {
      // console.warn('this table has empty head');
    }
    if (this.rows) {
      // console.warn('this table has no rows data');
    }
  }
}